import { render, staticRenderFns } from "./PercentageLoader.vue?vue&type=template&id=57b4c694&"
import script from "./PercentageLoader.vue?vue&type=script&lang=js&"
export * from "./PercentageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports